export const PRE_AUDIT_BASE_ROUTE = "/pre-audit";

export const PRE_AUDIT_ROLE_ROUTES = Object.freeze({
  admin: `${PRE_AUDIT_BASE_ROUTE}/admin`,
  reviewer: `${PRE_AUDIT_BASE_ROUTE}/reviewer`,
  supplier: `${PRE_AUDIT_BASE_ROUTE}/supplier`,
});

export function preAuditRoles(value) {
  return Array.isArray(value)
    ? [...new Set(value.filter((role) => ["admin", "reviewer", "supplier"].includes(role)))]
    : [];
}

export function preAuditLandingRole(roles) {
  return ["admin", "reviewer", "supplier"]
    .find((role) => preAuditRoles(roles).includes(role)) || null;
}
